import { applyMiddleware, createStore, compose, configureStore, Tuple } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { thunk } from 'redux-thunk';
import promise, { FluxStandardAction } from 'redux-promise-middleware';
import { useDispatch } from 'react-redux';
import reducers from '../reducers/index';
import { ThunkFlexibleDispatch } from '../../types/global';

const isDev = process.env.NODE_ENV === 'development';
const middleware = [thunk, promise, ...(isDev ? [logger] : [])];

/* eslint-disable no-underscore-dangle */
// @ts-ignore
const composeEnhancers = (isDev && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
/* eslint-enable */
const store = createStore(reducers, composeEnhancers(applyMiddleware(...middleware)));

export default store;

export type AppDispatch = ThunkFlexibleDispatch & ((action: FluxStandardAction) => Promise<any>);
export const useAppDispatch = () => useDispatch<AppDispatch>();

// used for testing
export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: reducers,
    middleware: () => new Tuple(thunk),
    preloadedState,
  });
};

export type RootState = ReturnType<typeof reducers>;
export type AppStore = ReturnType<typeof setupStore>;
